import SpinModel from '../../../core/src/model/SpinModel';
import { ICondition } from '../../../core/src/states/State';
import VendorModel from '../../model/VendorModel';

export default class ShouldExitFreeGamesCondition implements ICondition {
    check(): boolean {
        let isInFreeGames =
            //SpinModel.inFreegames() &&  // allow to resolve this condition if refresh on the last free games(skip showing on awarded board if spins are 0)
            VendorModel.freeGames != null &&
            VendorModel.freeGames != undefined;

        return (
            isInFreeGames && VendorModel.freeGames.spins === 0
            // (VendorModel.freeGames.spins === 0 || freeGamesExpired)
        );
    }
}
